var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',{attrs:{"xs10":""}},[_c('div',{staticStyle:{"margin":"0 20px"}},[_c('p',[_vm._v(_vm._s(_vm.theLabel))]),_c('v-textarea',{attrs:{"outline":"","no-resize":"","change":_vm.onValueChanged},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)]),_c('v-flex',{attrs:{"xs2":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }